import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getExpenses } from '../../../../fetch/axios.js';
import PlaceholderPage from '../../../common/PlaceholderPage/PlaceholderPage';
const Forecasting = () => {
  const { t } = useTranslation('pages');
  const fetchData = async () => {
    try {
      await getExpenses().then(() => {
        console.log('OK');
      });
    }
    catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <PlaceholderPage pageName={t('forecasting.title')} />
  );
};
export default Forecasting;
